export const calculateValidity = (validFrom: string, validTo: string): { weeks: number; days: number } => {
  const fromDate = new Date(validFrom);
  const toDate = new Date(validTo);
  const diffTime = toDate.getTime() - fromDate.getTime();

  const validityWeeks = Math.ceil(diffTime / (1000 * 3600 * 24 * 7));
  const validityDays = Math.ceil(diffTime / (1000 * 3600 * 24));

  return { weeks: validityWeeks, days: validityDays };
};

export function getUserTimezoneAbbreviation() {
  const options = { timeZoneName: "short" };
  const timeZone = new Intl.DateTimeFormat("en-US", options).format(new Date());
  // A abreviação do fuso horário será o último valor retornado
  const timeZoneAbbreviation = timeZone.split(" ")[1];

  return timeZoneAbbreviation;
}
